import React, { Component } from 'react';
import { Card, Button, CardHeader, CardBody, Label, Table, Progress, Row, Col, FormGroup, Input, Alert } from 'reactstrap';
import { FaPlusCircle } from 'react-icons/fa';
import FaTrash from "../../imgs/deleteIcon.png"
import MensajeModal from "../MensajeModal"
import { OBTENER_URL_SERVICIO } from "../../constants/action-types";
import axios from "axios";
import Timer from "react-time-counter";

class TablaClienteRol extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modalEstado: false,
            modalTitulo: "",
            modalMensaje: "",
            modalFooter: "",
            datosTraidos: [],

            listaRoles: [],
            listaModulos: [],
            listaClientes: [],
            modalIDCliente: "",
            modalIDRol: "",
            modalIDModulo: "",
            requiereModulo: false,
            hayModulos: false,
        };
        this.toggle = this.toggle.bind(this);
        this.modalNuevo = this.modalNuevo.bind(this);
        this.modalEliminar = this.modalEliminar.bind(this);
        this.buscarDatos = this.buscarDatos.bind(this);
        this.borrarSeleccion = this.borrarSeleccion.bind(this);
        this.agregarDato = this.agregarDato.bind(this);
        this.handleSelectAux = this.handleSelectAux.bind(this);
        this.handleSelectDatos = this.handleSelectDatos.bind(this);
        this.handleSelectModulo = this.handleSelectModulo.bind(this);
    }

    toggle() {
        this.setState({
            modalEstado: !this.state.modalEstado
        });
    }

    async handleSelectAux(e) {

        await this.setState({
            modalIDRol: e.target.selectedOptions[0].value
        })
        var opcionesCliente = this.state.listaClientes.map(p => {
            return (<option key={p.clienteCedulaP} value={p.clienteCedulaP} id={p.clienteCedulaP} name={p.namCliente + " " + p.apellidoCliente}>{p.namCliente + " " + p.apellidoCliente} </option>)
        });


        var opcionesAreas = [];
        var opcionesModulos = [];
        if (this.state.hayModulos === true) {
            opcionesModulos = this.state.listaModulos.map(p => {
                return (<option key={p[0]} value={p[0]} id={p[0]} name={p[1] + " / " + p[3]}>{p[1] + " / " + p[3]} </option>)
            });
            opcionesAreas = this.state.listaRoles.map(p => {
                return (<option key={p[0]} value={p[0]} id={p[0]} name={p[1]}>{p[1]} </option>)
            });
        } else {
            opcionesModulos = <option key={" "} value={" "} id={" "} name={" "}>{" "} </option>;
            for (var i = 0; i < this.state.listaRoles.length; i++) {
                var z = this.state.listaRoles[i]
                if (!(z[0] === 3 || z[0] === "3")) {
                    opcionesAreas.push(<option key={z[0]} value={z[0]} id={z[0]} name={z[1]}>{z[1]} </option>);
                }
            }
        }

        if (this.state.hayModulos === true && this.state.modalIDRol === "3") {

            await this.setState({
                requiereModulo: true
            })
            this.setState({
                modalTitulo: "Agregar",
                modalMensaje:
                    <Row>
                        <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                            <center>
                                <Label>Por favor ingresa los datos a modificar:</Label>
                            </center>
                        </Col>
                        <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                            <center>
                                <FormGroup>
                                    <Label for="exampleEmail">Nombre Cliente</Label>
                                    <Input defaultValue={this.state.modalIDCliente} onChange={this.handleSelectDatos} style={{ marginTop: "-12px", marginBottom: "7px" }} bsSize="sm" type="select" name="selectCliente" id="selectCliente">
                                        {opcionesCliente}
                                    </Input>
                                </FormGroup>
                            </center>
                        </Col>
                        <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                            <center>
                                <FormGroup>
                                    <Label for="exampleEmail">Rol</Label>
                                    <Input defaultValue={this.state.modalIDRol} onChange={this.handleSelectAux} style={{ marginTop: "-12px", marginBottom: "7px" }} bsSize="sm" type="select" name="selectRol" id="selectRol">
                                        {opcionesAreas}
                                    </Input>
                                </FormGroup>
                            </center>
                        </Col>
                        <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                            <center>
                                <FormGroup>
                                    <Label for="exampleEmail">Módulo</Label>
                                    <Input defaultValue={this.state.modalIDModulo} onChange={this.handleSelectModulo} style={{ marginTop: "-12px", marginBottom: "7px" }} bsSize="sm" type="select" name="selectMod" id="selectMod">
                                        {opcionesModulos}
                                    </Input>
                                </FormGroup>
                            </center>
                        </Col>
                    </Row>,
                modalFooter: <div>
                    <Button color="secondary" onClick={this.toggle}>Cancelar</Button>{' '}
                    <Button onClick={this.agregarDato} color="success">Agregar</Button>
                </div>
            })
        } else {
            await this.setState({
                requiereModulo: false
            })
            this.setState({
                modalTitulo: "Agregar",
                modalMensaje:
                    <Row>
                        <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                            <center>
                                <Label>Por favor ingresa los datos a modificar:</Label>
                            </center>
                        </Col>
                        <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                            <center>
                                <FormGroup>
                                    <Label for="exampleEmail">Nombre Cliente</Label>
                                    <Input defaultValue={this.state.modalIDCliente} onChange={this.handleSelectDatos} style={{ marginTop: "-12px", marginBottom: "7px" }} bsSize="sm" type="select" name="selectCliente" id="selectCliente">
                                        {opcionesCliente}
                                    </Input>
                                </FormGroup>
                            </center>
                        </Col>
                        <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                            <center>
                                <FormGroup>
                                    <Label for="exampleEmail">Rol</Label>
                                    <Input defaultValue={this.state.modalIDRol} onChange={this.handleSelectAux} style={{ marginTop: "-12px", marginBottom: "7px" }} bsSize="sm" type="select" name="selectRol" id="selectRol">
                                        {opcionesAreas}
                                    </Input>
                                </FormGroup>
                            </center>
                        </Col>
                    </Row>,
                modalFooter: <div>
                    <Button color="secondary" onClick={this.toggle}>Cancelar</Button>{' '}
                    <Button onClick={this.agregarDato} color="success">Agregar</Button>
                </div>
            })
        }
    }

    async handleSelectDatos(e) {
        await this.setState({
            modalIDCliente: e.target.selectedOptions[0].value
        })
    }

    async handleSelectModulo(e) {
        await this.setState({
            modalIDModulo: e.target.selectedOptions[0].value
        })
    }

    async componentDidMount() {
        this.setState({
            modalTitulo: "Cargando",
            modalMensaje:
                <div>
                    <p>Estamos buscando datos, ¡Por favor espera!</p>
                </div>,
            modalFooter: <div style={{ width: "100%" }}>
                <Progress animated color="success" value="100" />
            </div>
        })
        this.toggle();
        await this.buscarDatos(true);
    }

    async buscarDatos(bool) {

        try {
            const response = await axios.get(OBTENER_URL_SERVICIO + "/clientesRol");
            await this.setState({
                datosTraidos: response.data
            })

            const response2 = await axios.get(OBTENER_URL_SERVICIO + "/roles");
            await this.setState({
                listaRoles: response2.data
            })

            const response3 = await axios.get(OBTENER_URL_SERVICIO + "/modulosDistinct");
            await this.setState({
                listaModulos: response3.data
            })

            const response4 = await axios.get(OBTENER_URL_SERVICIO + "/clientes");
            await this.setState({
                listaClientes: response4.data
            })

            if (bool === true) {
                if (this.state.listaModulos.length <= 0 || this.state.listaModulos.length === 0) {
                    this.setState({
                        hayModulos: false,
                        modalTitulo: "¡Alerta!",
                        modalMensaje:
                            <div>
                                <center>
                                    <p>No existen módulos libres, por lo que agregar el rol de "Agente" no será posible.</p>
                                </center>
                            </div>,
                        modalFooter: <div style={{ width: "100%" }}>
                            <center>
                                <Label><Timer seconds={7} backward={true} id="timerTiempoModalX" label={<span></span>} /></Label>
                            </center>
                        </div>,
                    })
                    setTimeout(
                        function () {
                            this.toggle();
                        }
                            .bind(this),
                        7000
                    );
                } else {
                    this.setState({
                        hayModulos: true
                    })
                    this.toggle();
                }

            } else {
                if (this.state.listaModulos.length <= 0 || this.state.listaModulos.length === 0) {
                    this.setState({
                        hayModulos: false
                    })
                } else {
                    this.setState({
                        hayModulos: true
                    })
                }
            }
        }
        catch{
            await this.setState({
                datosTraidos: ""
            })

            if (bool === true) {
                this.toggle();
            }
        }
    }

    async modalNuevo() {
        var opcionesCliente = this.state.listaClientes.map(p => {
            return (<option key={p.clienteCedulaP} value={p.clienteCedulaP} id={p.clienteCedulaP} name={p.namCliente + " " + p.apellidoCliente}>{p.namCliente + " " + p.apellidoCliente} </option>)
        });

        var opcionesAreas = [];
        var opcionesModulos;
        if (this.state.hayModulos === true) {
            opcionesModulos = this.state.listaModulos.map(p => {
                return (<option key={p[0]} value={p[0]} id={p[0]} name={p[1] + " / " + p[3]}>{p[1] + " / " + p[3]} </option>)
            });
            opcionesAreas = this.state.listaRoles.map(p => {
                return (<option key={p[0]} value={p[0]} id={p[0]} name={p[1]}>{p[1]} </option>)
            });
            await this.setState({
                auxID: 999,
                modalIDCliente: this.state.listaClientes[0].clienteCedulaP,
                modalIDRol: this.state.listaRoles[0][0],
                modalIDModulo: this.state.listaModulos[0][0]
            })
        } else {
            opcionesModulos = <option key={" "} value={" "} id={" "} name={" "}>{" "} </option>;
            for (var i = 0; i < this.state.listaRoles.length; i++) {
                var z = this.state.listaRoles[i]
                if (!(z[0] === 3 || z[0] === "3")) {
                    opcionesAreas.push(<option key={z[0]} value={z[0]} id={z[0]} name={z[1]}>{z[1]} </option>);
                }
            }
            await this.setState({
                auxID: 999,
                modalIDCliente: this.state.listaClientes[0].clienteCedulaP,
                modalIDRol: this.state.listaRoles[0][0],
                modalIDModulo: ""
            })
        }

        if (this.state.hayModulos === true && this.state.modalIDRol === "3") {
            await this.setState({
                requiereModulo: true
            })
            if (this.state.hayModulos === true) {
                await this.setState({
                    modalIDModulo: this.state.listaModulos[0][0],
                })
            } else {
                await this.setState({
                    modalIDModulo: " ",
                })
            }
            this.setState({
                modalIDCliente: this.state.listaClientes[0].clienteCedulaP,
                modalIDRol: this.state.listaRoles[0][0],
                modalTitulo: "Agregar",
                modalMensaje:
                    <Row>
                        <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                            <center>
                                <Label>Por favor ingresa los datos a modificar:</Label>
                            </center>
                        </Col>
                        <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                            <center>
                                <FormGroup>
                                    <Label for="exampleEmail">Nombre Cliente</Label>
                                    <Input defaultValue={this.state.modalIDCliente} onChange={this.handleSelectDatos} style={{ marginTop: "-12px", marginBottom: "7px" }} bsSize="sm" type="select" name="selectCliente" id="selectCliente">
                                        {opcionesCliente}
                                    </Input>
                                </FormGroup>
                            </center>
                        </Col>
                        <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                            <center>
                                <FormGroup>
                                    <Label for="exampleEmail">Rol</Label>
                                    <Input defaultValue={this.state.modalIDRol} onChange={this.handleSelectAux} style={{ marginTop: "-12px", marginBottom: "7px" }} bsSize="sm" type="select" name="selectRol" id="selectRol">
                                        {opcionesAreas}
                                    </Input>
                                </FormGroup>
                            </center>
                        </Col>
                        <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                            <center>
                                <FormGroup>
                                    <Label for="exampleEmail">Módulo</Label>
                                    <Input defaultValue={this.state.modalIDModulo} onChange={this.handleSelectModulo} style={{ marginTop: "-12px", marginBottom: "7px" }} bsSize="sm" type="select" name="selectMod" id="selectMod">
                                        {opcionesModulos}
                                    </Input>
                                </FormGroup>
                            </center>
                        </Col>
                    </Row>,
                modalFooter: <div>
                    <Button color="secondary" onClick={this.toggle}>Cancelar</Button>{' '}
                    <Button onClick={this.agregarDato} color="success">Agregar</Button>
                </div>
            })
        } else {
            await this.setState({
                requiereModulo: false
            })
            if (this.state.hayModulos === true) {
                await this.setState({
                    modalIDModulo: this.state.listaModulos[0][0],
                })
            } else {
                await this.setState({
                    modalIDModulo: " ",
                })
            }
            this.setState({
                modalIDCliente: this.state.listaClientes[0].clienteCedulaP,
                modalIDRol: this.state.listaRoles[0][0],
                modalTitulo: "Agregar",
                modalMensaje:
                    <Row>
                        <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                            <center>
                                <Label>Por favor ingresa los datos a modificar:</Label>
                            </center>
                        </Col>
                        <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                            <center>
                                <FormGroup>
                                    <Label for="exampleEmail">Nombre Cliente</Label>
                                    <Input defaultValue={this.state.modalIDCliente} onChange={this.handleSelectDatos} style={{ marginTop: "-12px", marginBottom: "7px" }} bsSize="sm" type="select" name="selectCliente" id="selectCliente">
                                        {opcionesCliente}
                                    </Input>
                                </FormGroup>
                            </center>
                        </Col>
                        <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                            <center>
                                <FormGroup>
                                    <Label for="exampleEmail">Rol</Label>
                                    <Input defaultValue={this.state.modalIDRol} onChange={this.handleSelectAux} style={{ marginTop: "-12px", marginBottom: "7px" }} bsSize="sm" type="select" name="selectRol" id="selectRol">
                                        {opcionesAreas}
                                    </Input>
                                </FormGroup>
                            </center>
                        </Col>
                    </Row>,
                modalFooter: <div>
                    <Button color="secondary" onClick={this.toggle}>Cancelar</Button>{' '}
                    <Button onClick={this.agregarDato} color="success">Agregar</Button>
                </div>
            })
        }
        this.toggle();
    }
    async agregarDato() {
        this.setState({
            modalTitulo: "Procesando",
            modalMensaje:
                <div>
                    <p>¡Estamos procesando la acción, espera por favor!</p>
                </div>,
            modalFooter: <div style={{ width: "100%" }}>
                <Progress animated color="success" value="100" />
            </div>
        })
        var envioDatos = {}
        if (this.state.requiereModulo === true) {
            envioDatos = {
                secClienteRol: null,
                clienteCedula: this.state.modalIDCliente,
                secEstado: null,
                secModulo: this.state.modalIDModulo,
                secRol: this.state.modalIDRol
            }
        } else {
            envioDatos = {
                secClienteRol: null,
                clienteCedula: this.state.modalIDCliente,
                secEstado: null,
                secModulo: null,
                secRol: this.state.modalIDRol
            }
        }
        try {
            const response = await axios.post(OBTENER_URL_SERVICIO + "/clienteRol/new", envioDatos);
            if (response.data.tipo === "EXITO") {
                this.setState({
                    modalTitulo: "Exito",
                    modalMensaje:
                        <div>
                            <p>¡Dato agregado!</p>
                        </div>,
                    modalFooter: <div>
                        <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                    </div>
                })
            } else {
                if (response.data.tipo === "ERROR") {
                    this.setState({
                        modalTitulo: "Error",
                        modalMensaje:
                            <div>
                                <p>No se puede procesar la acción, intenta de nuevo más tarde.</p>
                            </div>,
                        modalFooter: <div>
                            <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                        </div>
                    })
                } else {
                    this.setState({
                        modalTitulo: "Error",
                        modalMensaje:
                            <div>
                                <p>No se puede procesar la acción, intenta de nuevo más tarde.</p>
                            </div>,
                        modalFooter: <div>
                            <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                        </div>
                    })
                }
            }
            this.buscarDatos(false)
        }
        catch (error) {
            const response = await axios.get(OBTENER_URL_SERVICIO + "/clientesRol");
            await this.setState({
                datosTraidos: response.data
            })
            const response2 = await axios.get(OBTENER_URL_SERVICIO + "/roles");
            await this.setState({
                listaRoles: response2.data
            })
            const response3 = await axios.get(OBTENER_URL_SERVICIO + "/modulosDistinct");
            await this.setState({
                listaModulos: response3.data
            })
            const response4 = await axios.get(OBTENER_URL_SERVICIO + "/clientes");
            await this.setState({
                listaClientes: response4.data
            })

            this.setState({
                modalTitulo: "Error",
                modalMensaje:
                    <div>
                        <center>
                            <p>Tu solicitud no puede ser enviada ahora mismo. Por favor intenta más tarde. (500 Error)</p>
                        </center>
                    </div>,
                modalFooter: <div style={{ width: "100%" }}>
                    <center>
                        <Label><Timer seconds={5} backward={true} id="timerTiempoModalX" label={<span></span>} /></Label>
                    </center>
                </div>,
            })
            setTimeout(
                function () {
                    this.toggle();
                }
                    .bind(this),
                5000
            );
        }
    }

    modalEliminar(event) {
        this.setState({
            modalTitulo: "Eliminar",
            modalMensaje:
                <Row>
                    <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                        <center>
                            <Label>¡ATENCIÓN!</Label>
                            <br />
                            <Label>Se eliminará el dato seleccionado.</Label>
                        </center>
                    </Col>
                </Row>,
            modalFooter: <div>
                <Button color="secondary" onClick={this.toggle}>Cancelar</Button>{' '}
                <Button id={event.target.id} onClick={this.borrarSeleccion} color="danger">Eliminar</Button>
            </div>
        })
        this.toggle();
    }
    async borrarSeleccion(event) {
        this.setState({
            modalTitulo: "Procesando",
            modalMensaje:
                <div>
                    <p>¡Estamos procesando la acción, espera por favor!</p>
                </div>,
            modalFooter: <div style={{ width: "100%" }}>
                <Progress animated color="success" value="100" />
            </div>
        })
        try {
            const response = await axios.delete(OBTENER_URL_SERVICIO + "/clienteRol/" + event.target.id);
            if (response.data.tipo === "EXITO") {
                this.setState({
                    modalTitulo: "EXITO",
                    modalMensaje:
                        <div>
                            <p>¡Dato eliminado con éxito!</p>
                        </div>,
                    modalFooter: <div>
                        <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                    </div>
                })
            } else {
                if (response.data.tipo === "NO ENCONTRADO") {
                    this.setState({
                        modalTitulo: "Dato no encontrada",
                        modalMensaje:
                            <div>
                                <p>No se encontró el dato para eliminar.</p>
                                <p>¡Quizás alguien se adelantó!</p>
                            </div>,
                        modalFooter: <div>
                            <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                        </div>
                    })
                } else {
                    this.setState({
                        modalTitulo: "Error",
                        modalMensaje:
                            <div>
                                <p>Por favor, intenta de nuevo más tarde.</p>
                            </div>,
                        modalFooter: <div>
                            <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                        </div>
                    })
                }
            }
            this.buscarDatos(false)
        }
        catch (error) {
            const response = await axios.get(OBTENER_URL_SERVICIO + "/clientesRol");
            await this.setState({
                datosTraidos: response.data
            })
            const response2 = await axios.get(OBTENER_URL_SERVICIO + "/roles");
            await this.setState({
                listaRoles: response2.data
            })
            const response3 = await axios.get(OBTENER_URL_SERVICIO + "/modulosDistinct");
            await this.setState({
                listaModulos: response3.data
            })
            const response4 = await axios.get(OBTENER_URL_SERVICIO + "/clientes");
            await this.setState({
                listaClientes: response4.data
            })

            this.setState({
                modalTitulo: "Error",
                modalMensaje:
                    <div>
                        <center>
                            <p>Tu solicitud no puede ser enviada ahora mismo. Por favor intenta más tarde. (500 Error)</p>
                        </center>
                    </div>,
                modalFooter: <div style={{ width: "100%" }}>
                    <center>
                        <Label><Timer seconds={5} backward={true} id="timerTiempoModalX" label={<span></span>} /></Label>
                    </center>
                </div>,
            })
            setTimeout(
                function () {
                    this.toggle();
                }
                    .bind(this),
                5000
            );
        }

    }

    render() {

        var datosTabla =
            <Alert color="primary">
                No hay Roles asociados a los Clientes.
</Alert>

        if (this.state.datosTraidos !== null && this.state.datosTraidos !== undefined && this.state.datosTraidos.length > 0) {
            datosTabla =
                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Nombre Cliente</th>
                            <th>Rol</th>
                            <th>Módulo</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.datosTraidos.map(p => {
                            return (
                                <tr key={p[0]}>
                                    <th scope="row">{p[0]}</th>
                                    <td>{p[1]}</td>
                                    <td>{p[3]}</td>
                                    <td>{p[5]}</td>
                                    <td><Button size="sm" color="danger" id={p[0]} onClick={this.modalEliminar} ><img style={{ verticalAlign: "middle" }} height="15" src={FaTrash} id={p[0]} alt="borrar" /></Button></td>
                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
        }

        return (
            <div>
                <MensajeModal modal={this.state.modalEstado} titulo={this.state.modalTitulo} toggle={this.toggle} mensaje={this.state.modalMensaje} footer={this.state.modalFooter} ></MensajeModal>
                <CardBody>
                    <Card>
                        <CardHeader style={{ backgroundColor: "#c0d6e4" }}> <Label style={{ color: "black", fontSize: "25px" }}>Gestionar Roles de Clientes </Label> <Button className="btn btn-success float-right" onClick={this.modalNuevo}><FaPlusCircle></FaPlusCircle> Agregar Roles de Clientes</Button></CardHeader>
                        <CardBody>
                            {datosTabla}
                        </CardBody>
                    </Card>
                </CardBody>
            </div>
        );
    }
}

export default TablaClienteRol;